import ThankYou from "./components";

export default ThankYou;
